import { defineComponent as _defineComponent } from 'vue'
import { InitialHoldInterface } from "@/types/InitialHoldInterface";
  import { LotStatus } from "@/enums/LotStatus";
  import { getLotStatusClass } from "@/helpers/status";
  import { computed } from "vue";
  import { formatDate } from "@/helpers/date";
  import { formatPrice as formatNumbers } from "@/helpers/transformation/price";

  interface Props {
    title: string;
    data: {
      firstName: string;
      lastName: string;
      email: string;
      phone: string;
      companyDetails?: string;
      holderType?: string;
    };
    initialHold: InitialHoldInterface;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InitialHoldDetailsCard',
  props: {
    title: {},
    data: {},
    initialHold: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, get InitialHoldInterface() { return InitialHoldInterface }, get LotStatus() { return LotStatus }, get getLotStatusClass() { return getLotStatusClass }, computed, get formatDate() { return formatDate }, get formatNumbers() { return formatNumbers } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})